<template>
  <!--Page Container View Mode-->
  <div :style="this.$store.state.style">
    <div class="select-page-dropdown">
      <select @change="onChange($event)" v-if="pages.length > 1">
        <option
          v-for="page in pages"
          :key="page.id"
          :value="page.id"
          @click="onClick(page)"
        >
          {{ page.name }}
        </option>
      </select>
    </div>
    <div
      class="access-denied"
      v-if="selectedPage && selectedPage.nodes.length == 0"
    >
      You currently don't have permission to access any application. Please
      contact your local sales representative or send an email to
      <a href="mailto:seedselector@agconnections.com">Support Email</a>
    </div>
    <vue-glide
      v-if="selectedPage && selectedPage.nodes.length > 0"
      class="demo"
      :breakpoints="this.$store.state.style['--breakpoints']"
      :gap="this.$store.state.style['--cards_gap']"
      :keyboard="this.$store.state.style['--bullets_keyboard']"
      :bullet="this.$store.state.style['--bullets_keyboard']"
    >
      <vue-glide-slide v-for="node in selectedPage.nodes" :key="node.node">
        <component
          :is="node.component_name"
          :key="node.masked_url"
          :name="node.name"
          :ref="node.name"
          :isNodeMinimized="node.isMinimized"
          :title="node.title"
          :description="node.description"
          :bgImg="node.bg_img"
          :logo="node.logo"
          v-on:app-selected="appSelected"
        ></component>
      </vue-glide-slide>
    </vue-glide>
    <div v-if="selectedPage">
      <div v-for="app in openedAppList" v-bind:key="app.uniqueId">
        <opened-app
          v-if="app.masked_url"
          :maskedUrl="app.masked_url"
          :appId="app.id"
          :appName="app.name"
          :appType="app.type"
          :isMinimized="app.isMinimized"
          v-on:iframe-closed="iframeClosed"
          v-on:iframe-minimized="iframeMinimized"
          ref="openedApp"
          :user="user"
        ></opened-app>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { Glide, GlideSlide } from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
import OpenedApp from "./../viewMode/OpenedApp.vue";
import portalAPI from "../../services/portalService.js";
import CookieLaw from "vue-cookie-law";

let api = new portalAPI();

export default {
  name: "ViewModeBoard",
  props: ["user"],
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    OpenedApp,
    CookieLaw,
  },
  data() {
    return {
      pages: [],
      selectedPage: null,
    };
  },
  methods: {
    onChange(event) {
      this.selectedPage = _.find(this.pages, (item) => {
        return item.id == event.target.value;
      });
      this.selectedPage.nodes = _.uniqBy(
        this.selectedPage.nodes.filter((x) => x.component_name != null),
        "id"
      );

      event.srcElement.blur();
    },
    appSelected(data) {
      let pageIndex = this.pages.findIndex((p) => p.id == this.selectedPage.id);
      let nodeIndex = this.pages[pageIndex].nodes.findIndex(
        (node) => node.masked_url == data.maskedUrl
      );

      if (pageIndex >= 0 && nodeIndex >= 0) {
        if (this.pages[pageIndex].nodes[nodeIndex].isMinimized) {
          this.pages[pageIndex].nodes[nodeIndex].isMinimized = false;
        } else {
          this.pages[pageIndex].nodes[nodeIndex].isClosed = false;
          this.pages[pageIndex].nodes[nodeIndex].isOpened = true;
        }
        document.body.classList.add('overflow-hidden');
      }
    },
    iframeClosed(appId) {
      let selectedPageIndex = this.selectedPage.nodes.findIndex(
        (n) => n.id == appId
      );
      if (selectedPageIndex >= 0)
        this.selectedPage.nodes[selectedPageIndex].isClosed = true;

      let pageIndex = this.pages.findIndex((p) => p.id == this.selectedPage.id);
      let nodeIndex = this.pages[pageIndex].nodes.findIndex(
        (node) => node.id == appId
      );
      if (pageIndex >= 0 && nodeIndex >= 0)
        this.pages[pageIndex].nodes[nodeIndex].isOpened = false;
      
      document.body.classList.remove('overflow-hidden');
    },
    iframeMinimized(appId) {
      this.selectedPage.nodes.filter(
        (n) => n.id == appId
      )[0].isMinimized = true;

      document.body.classList.remove('overflow-hidden');
    },
    modifyNodesObjects() {
      this.pages.forEach((page) => {
        page.nodes = page.nodes.map((n) => ({
          ...n,
          isMinimized: false,
          isClosed: true,
          isOpened: false,
        }));
      });
    },
    openUerAgreement() {
      var agreementWindow = window.open(`./userAgreement.html`, "_blank");
      var elem = document.createElement("img");
      var imgPath = require(`../../assets/images/${this.$store.state.style["--footer_logo"]}`);
      elem.setAttribute("src", imgPath);

      agreementWindow.onload = function (e) {
        agreementWindow.document
          .getElementById("agreement-header")
          .appendChild(elem);
      };
    },
  },
  mounted() {
    let that = this;
    api.getUserPages().then((res) => {
      that.pages = res ? res.data.pages : [];

      if (that.pages.length) {
        that.pages[0].nodes.sort((a, b) => a.node_order - b.node_order);
        that.selectedPage = that.pages[0];
        that.selectedPage.nodes = _.uniqBy(
          that.selectedPage.nodes.filter((x) => x.component_name != null),
          "id"
        );

        that.modifyNodesObjects();
      }
    });
  },
  computed: {
    openedAppList: function () {
      let nodeList = [];
      this.pages.forEach((page) => {
        nodeList = nodeList.concat(
          page.nodes
            .filter((n) => n.isOpened == true)
            .map((n) => ({
              ...n,
              uniqueId: `${page.id}_${n.id}`,
            }))
        );
      });
      return nodeList;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.access-denied {
  background: #fcf8e3;
  width: 60%;
  position: absolute;
  left: 50%;
  top: 50%;
  color: #000;
  font-size: 18px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
  transform: translate(-50%, -50%);
  padding: 10px 1rem;
  border-radius: 3px;
}

.access-denied i {
  color: #f7941d;
  font-size: 23px;
  float: left;
  margin: 3px 10px 0 0;
}

.glide__slide {
  width: var(--card_width) !important;
  float: var(--slide_float);
  margin-bottom: var(--card_marginBottom);
  &:first-child {
    margin-left: var(--card_marginLeftFirst);
  }
}
.select-page-slide {
  background: rgba(209, 209, 209, 0.33);
  padding: 3rem 2rem;
  margin: 2rem 0 2rem 2rem;
  height: calc(100vh - 215px); /* fallback if css var is not supported*/
  height: calc(calc(var(--vh, 1vh) * 100) - 215px);
  width: 100%;
  box-shadow: 1px 0px 18px #00000038;
}
.select-page-dropdown {
  color: #2b3139;
}
.select-page-dropdown select {
  background: transparent url("../../assets/images/drop-down-arrow.png")
    no-repeat;
  border: none;
  color: #2b3139;
  font-size: 20px;
  font-weight: bold;
  background-position: right 12px;
  -webkit-appearance: none;
  appearance: none;
  margin: 25px 1rem 20px 3rem;
  padding: 0 55px 0 0;
}
.select-page-dropdown select:focus {
  outline: none;
}
.select-page-dropdown select option {
  font-size: 18px;
}
.select-page-dropdown label {
  font-weight: 600;
  color: #009370;
}
.view-slide {
  width: 100%;
  height: var(--slide_height);
  //calc(100vh - 150px); /* fallback if css var is not supported*/
  // height: calc(calc(var(--vh, 1vh) * 100) - 150px);
  float: left;
  // display: inline-flex;
  position: relative;
  color: var(--card_h3_color);
  background: var(--card_bg) !important;
  border: var(--card_border);
  box-shadow: var(--card_shadow);
  padding: var(--card_padding);
  border-radius: var(--card_border-radius);
  display: var(--card_display);
  flex-direction: var(--card_flex-dir);
  &:hover {
    img {
      filter: var(--slide_hover_img_filter);
    }
    .slide-text-part p {
      transition: opacity 0.5s linear;
      opacity: 1;
      //display: var(--slide_hover_display);
    }
    .slide-text-part button {
      transition: opacity 0.5s linear;
      opacity: 1;
      //display: var(--slide_hover_display);
    }
  }
}
.view-slide img {
  float: none;
  height: var(--card_image_height);
  width: var(--card_image_width);
  position: var(--card_image_position);
  top: var(--card_image_position_top);
}
.view-slide i.fa-chevron-down {
  position: absolute;
  bottom: 0.5rem;
  left: 50%;
  transform: translateY(-50%);
  font-size: 1.2rem;
  color: #fff;
}
.view-slide button.more-icon {
  background: transparent;
  border: none;
}
.view-slide.sentio-slide {
  background: linear-gradient(to bottom right, #83cfcd, #609b1c);
}
.view-slide.SA-slide {
  background: linear-gradient(to bottom right, #568017, #f08506);
}
.view-slide.PO-slide {
  background: linear-gradient(to bottom right, #6b3200, #e9d772);
}
.view-slide.PSS-slide {
  background: linear-gradient(to bottom right, #588317, #f08507);
}
.view-slide.FS-slide {
  background: linear-gradient(to bottom right, #58752c, #fbd45f);
}
.view-slide.SR-slide {
  background: linear-gradient(to bottom right, #753d2c, #fbd45f);
}
.view-slide.BS-slide {
  background: linear-gradient(to bottom right, #133d57, #236c9b);
}
.view-slide.ag-slide {
  background: linear-gradient(to bottom right, #18303c, #87d44f);
}
.view-slide .slide-text-part {
  padding: 1.5rem;
  position: relative;
  // overflow: hidden;
  height: var(--slide_text-height);
}
.view-slide .slide-text-part p {
  font-size: 13px;
  color: var(--card_color);
  margin: var(--card_p_margin);
  opacity: var(--card_p_display);
}
.view-slide .slide-text-part span.minimized-indicator {
  display: block;
  width: 15px;
  height: 15px;
  background: #bbbaba;
  border-radius: 50%;
  float: var(--min_ind_float);
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  margin: 9px 15px;
  position: relative;
  &:hover .tooltip {
    opacity: 1;
    background: var(--tooltip_color);
    color: #fff;
    font-weight: bold;
    padding: 0 10px;
    border-radius: 5px;
    font-size: 12px;
    height: 24px;
    line-height: 22px;
    top: -32px;
    left: -23px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: var(--tooltip_color) transparent transparent transparent;
    }
    .opened {
      display: none;
    }
  }
}
.view-slide[isnodeminimized="true"] .slide-text-part span.minimized-indicator {
  background: #80c94e;
  .opened {
    display: block !important;
  }
  .closed {
    display: none;
  }
}

.card-cont[isnodeminimized="true"]
  .view-slide
  .slide-text-part
  span.minimized-indicator {
  background: #80c94e;
  .opened {
    display: block !important;
  }
  .closed {
    display: none;
  }
}
.view-slide .slide-text-part img {
  height: auto;
  float: left;
  width: auto;
  max-width: 200px;
  max-height: 55px;
  margin-bottom: 10px;
}
.view-slide .slide-text-part img + span.minimized-indicator {
  margin: 12px 0 0 15px !important;
}
.view-slide .slide-text-part.more-opened .more-content {
  top: 0;
}
.view-slide .slide-text-part .more-content {
  position: absolute;
  top: 100%;
  background: #fff;
  color: #000;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2rem;
  transition: all 0.3s ease;
}
.view-slide .slide-text-part .more-content button {
  background: #00ccc1;
  color: #fff;
  border-radius: 20px;
  border: none;
  padding: 0.5rem 2rem;
}
.view-slide .slide-text-part .more-content button.close-more {
  background: transparent;
  color: #00ccc1;
  font-weight: bold;
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
}
.view-slide .slide-text-part .more-content button:focus {
  outline: none;
}
.view-slide h3 {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
  float: left;
  line-height: 38px;
  margin-left: var(--card_h3_margin);
}
.view-slide hr {
  border-top: 3px solid rgba(255, 255, 255, 0.4);
  width: 5rem;
  margin: 1rem 0;
}
.view-slide .icons {
  border: dashed 1px #fff;
  padding: 1rem;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  text-align: center;
  margin-bottom: 1rem;
  margin: auto;
}
.view-slide hr.dashed {
  border-top: dashed 1px #fff;
  float: left;
  margin: 2rem 1rem;
  width: 50%;
  min-width: 200px;
}
.view-slide .icons img {
  height: auto;
  margin: auto;
  float: none;
}
.glide__bullets {
  text-align: center;
  opacity: var(--card_p_display);
}
.glide__bullet {
  height: 12px;
  width: 12px !important;
  border-radius: 50%;
  margin: 5px;
  padding: 5px;
  border: 0;
  background: var(--bullets_bg);
  transition: all 0.3s ease;
  display: inline-block;
}
.glide__bullet:focus {
  outline: none;
}

/* .glide__bullet:last-child {
   display: none;
} */

.glide__bullet.glide__bullet--active,
button.glide__bullet:hover {
  background: var(--button_success);
}

/* @media screen and (max-width: 850px) {
   .view-slide > img {
     display: none;
  }
 } */

footer {
  width: 100%;
  color: #2b3139;
  font-size: 12px;
  padding: 10px 35px;
}
footer a,
footer a:hover {
  color: var(--footer_color) !important;
  margin-right: 10px;
}
footer a:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
footer label {
  border-right: 1px solid #2b3139;
  padding-right: 15px;
  margin-right: 15px;
  color: var(--footer_color);
}
footer a.cookie_policy,
footer a.cookie_policy:hover {
  color: var(--cookiePolicy_color) !important;
}
@media screen and (min-height: 650px) {
  footer {
    position: absolute;
    bottom: 0;
    &.footer {
      position: var(--footer_position_mobile);
    }
  }
}
@media screen and (max-height: 750px) {
  .select-page-dropdown select {
    margin: 10px 1rem 10px 3rem;
  }
  .view-slide .slide-text-part {
    padding: 0.75rem 1.5rem;
    height: var(--slide_text-height-mobile);
  }
  .view-slide {
    height: var(--card_height);
  }
  .view-slide .slide-text-part p {
    font-size: 12px;
  }
  .view-slide .slide-text-part img {
    max-width: 165px;
    max-height: 40px;
  }
}
@media screen and (min-height: 850px) {
  .glide {
    margin-top: var(--glide-margin-top) !important;
  }
}
.glide {
  margin-top: var(--glide_marginTop);
  padding: 0 3rem;
  margin-left: var(--glide_margin);
}
.Cookie--base--rounded .Cookie__button {
  background: var(--button_success) !important;
}
</style>
